/* Product gallery arrows, size-row arrows, and product rails. */
(() => {
  const hideScrollbar = (element) => {
    element.style.scrollbarWidth = 'none';
  };

  const bindTrack = (track, previous, next, threshold = 0) => {
    if (!track) return;
    hideScrollbar(track);
    const items = track.querySelectorAll(':scope > input, :scope > label, :scope > li, :scope > *');
    const update = () => {
      const overflowing = track.scrollWidth > track.clientWidth + 4;
      const many = threshold > 0 && items.length > threshold;
      const show = overflowing || many;
      if (previous) previous.hidden = !show;
      if (next) next.hidden = !show;
      if (previous) previous.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    const move = (direction) => {
      track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.7, 160), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const enhanceGallery = (gallery) => {
    if (gallery.dataset.adelaideArrows) return;
    const thumbs = [...gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]')];
    if (thumbs.length < 2) return;
    gallery.dataset.adelaideArrows = 'true';
    const host = gallery.querySelector('.product__media-list')?.parentElement || gallery;
    host.style.position = host.style.position || 'relative';
    const previous = document.createElement('button');
    const next = document.createElement('button');
    previous.type = next.type = 'button';
    previous.className = 'adelaide-gallery-arrow adelaide-gallery-arrow--prev';
    next.className = 'adelaide-gallery-arrow adelaide-gallery-arrow--next';
    previous.setAttribute('aria-label', 'Previous image');
    next.setAttribute('aria-label', 'Next image');
    const step = (direction) => {
      const current = thumbs.findIndex((item) => item.querySelector('button[aria-current="true"]')) ;
      const index = (current + direction + thumbs.length) % thumbs.length;
      thumbs[index].querySelector('button')?.click();
    };
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    host.append(previous, next);
    let startX = 0;
    let startY = 0;
    let tracking = false;
    host.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      startX = event.clientX;
      startY = event.clientY;
      tracking = true;
    });
    const endSwipe = (event) => {
      if (!tracking) return;
      tracking = false;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) step(dx < 0 ? 1 : -1);
    };
    host.addEventListener('pointerup', endSwipe);
    host.addEventListener('pointercancel', () => { tracking = false; });
  };

  const enhanceSizes = (fieldset) => {
    if (fieldset.dataset.adelaideScroller) return;
    const options = [...fieldset.querySelectorAll('input[type=radio], .adelaide-size-option')];
    if (!options.length) return;
    fieldset.dataset.adelaideScroller = 'true';
    const track = document.createElement('div');
    track.className = 'adelaide-size-options__track';
    const row = document.createElement('div');
    row.className = 'adelaide-size-options__row';
    const previous = document.createElement('button');
    const next = document.createElement('button');
    previous.type = next.type = 'button';
    previous.className = 'adelaide-size-options__arrow adelaide-size-options__arrow--prev';
    next.className = 'adelaide-size-options__arrow adelaide-size-options__arrow--next';
    previous.setAttribute('aria-label', 'Previous sizes');
    next.setAttribute('aria-label', 'Next sizes');
    previous.hidden = next.hidden = true;
    const nodes = [...fieldset.childNodes].filter((node) => node.nodeType === 1 && !node.matches('legend, .form__label'));
    nodes.forEach((node) => track.append(node));
    row.append(previous, track, next);
    fieldset.append(row);
    bindTrack(track, previous, next, 10);
  };

  const enhanceRail = (rail) => {
    const track = rail.querySelector('[data-adelaide-rail-track]');
    if (!track || track.dataset.adelaideBound) return;
    track.dataset.adelaideBound = 'true';
    bindTrack(track, rail.querySelector('[data-adelaide-rail="-1"]'), rail.querySelector('[data-adelaide-rail="1"]'));
  };

  const enhance = (root = document) => {
    root.querySelectorAll('.adelaide-product media-gallery').forEach(enhanceGallery);
    root.querySelectorAll('.adelaide-size-options').forEach(enhanceSizes);
    root.querySelectorAll('[data-adelaide-product-rail]').forEach(enhanceRail);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  document.querySelectorAll('[data-adelaide-product-rail]').forEach((rail) => {
    new MutationObserver(() => enhanceRail(rail)).observe(rail, { childList: true, subtree: true });
  });
  document.querySelectorAll('.adelaide-product').forEach((product) => {
    new MutationObserver(() => enhance(product)).observe(product, { childList: true, subtree: true });
  });
})();
